import { j as i } from "../../../jsx-runtime-BwWtxLpl.js";
import j from "classnames";
import e from "prop-types";
import { useContext as I, useEffect as u } from "react";
import "../form-field/form-field.js";
import { FormFieldContext as N } from "../form-field/form-field.context.js";
let m;
m = 0;
const T = ({
  className: c = "",
  disabled: n = !1,
  id: r = "",
  required: a = !1,
  onBlur: f = () => null,
  onChange: p = () => null,
  onFocus: d = () => null,
  value: s = "",
  placeholder: x = "",
  ariaLabel: l = "",
  ...g
}) => {
  const t = I(N);
  u(() => {
    t.setRequired(a), t.setDisabled(n), t.setFormElementType("textAreaInput"), r ? t.setId(r) : t.setId(`motif-text-area-${m++}`);
  }, []), u(() => {
    t.setValue(s), t.setHasContent(s.length > 0);
  }, [s]);
  const h = (o) => {
    t.toggleFocus(o), f(o);
  }, F = (o) => {
    t.setValue(o.target.value), p(o);
  }, C = (o) => {
    t.toggleFocus(o), d(o);
  }, b = j({
    "motif-text-area": !0,
    "motif-input-invalid": t.invalid,
    [c]: !0
  });
  return /* @__PURE__ */ i.jsx("div", { className: "motif-input-component", "aria-label": l, "data-motif-text-area": !0, children: /* @__PURE__ */ i.jsx(
    "textarea",
    {
      ...g,
      id: t.id,
      className: b,
      onFocus: C,
      onBlur: h,
      onChange: F,
      value: s,
      disabled: n,
      required: a,
      placeholder: x,
      "aria-label": l
    }
  ) });
};
T.propTypes = {
  className: e.string,
  disabled: e.bool,
  required: e.bool,
  id: e.string,
  onBlur: e.func,
  onChange: e.func,
  onFocus: e.func,
  value: e.string,
  placeholder: e.string
};
export {
  T as MotifTextArea
};
